import { Modal } from "react-bulma-components";
import styled from "styled-components";

const PreserveWhitespaceSpan = styled.span`
  display: inline-block;
  white-space: pre;
`;

export const FullScreenDiv = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0px;
  left: 0px;
`;

export const FlexDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: row wrap;
  row-gap: 0px;
  column-gap: 0px;
  flex-wrap: wrap;
`;

export const CenteredDivGrid = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
`;

export const StyledText = styled.span`
  font: 1.2em Inconsolata;
  color: white;
`;

export const InvertedImage = styled.img`
  filter: invert(1);
  position: relative;
`;

export const FullScreenModalContent = styled(Modal.Content)`
  max-height: none;
  width: 80%;
  scrollbar-width: none;
`;

export function CareBraille(props) {
  return (
    <FlexDiv>
      <InvertedImage
        src={process.env.PUBLIC_URL + "/care/care-braille.png"}
        alt="Care Braille"
      ></InvertedImage>
    </FlexDiv>
  );
}

export function careCalendarMediaUrl(filename, index, dir="calendar") {
  return [process.env.PUBLIC_URL, "care", dir, index, filename].join(
    "/"
  );
}

export function careDataUrl(filename, index = "") {
  return [
    process.env.PUBLIC_URL,
    "care",
    filename.replace("<index>", index),
  ].join("/");
}

export default PreserveWhitespaceSpan;
